// core
import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

// constants
import {AppConstants} from './utils/constants';

// components
import {UserRegistrationComponent} from './user-registration/user-registration.component';
import {AdminUsersOverviewComponent} from './admin-users-overview/admin-users-overview.component';
import {UpdateMyProfileComponent} from './update-my-profile/update-my-profile.component';
import {EntryPageComponent} from './home-page/home-page.component';
import {ForgotPasswordComponent} from './forgot-password/forgot-password.component';
import {ConfirmationPageComponent} from './confirmation-page/confirmation-page.component';
import {EmailConfirmationComponent} from './email-confirmation/email-confirmation.component';
// import {ChangePasswordComponent} from './change-password/change-password.component';
import {MyProfileChangePasswordComponent} from './my-profile-change-password/my-profile-change-password.component';
import {SlxAdminManageCustomersComponent} from './slx-admin-manage-customers/slx-admin-manage-customers.component';
import {UserResolve} from './user/user.resolve';
import {
  CustomerAdminUserDetailsComponent
} from './user/customer-admin-user-details/customer-admin-user-details.component';
import {SlxAdminUserDetailsComponent} from './user/slx-admin-user-details/slx-admin-user-details.component';
import {SlxAdminManageUsersComponent} from './slx-admin-manage-users/slx-admin-manage-users.component';
import {ErrorPageComponent} from './error-page/error-page.component';
import {ResetPasswordComponent} from './reset-password/reset-password.component';
import {MyCompanyDataComponent} from './my-company-data/my-company-data.component';
import {CreateEditCustomerComponent} from './customer/create-edit-customer/create-edit-customer.component';
import {NewsletterAgreementComponent} from './newsletter-agreement/newsletter-agreement.component';
import {UnsavedChangesGuard} from './shared/unsaved-changes.guard';
import {ContactPersonComponent} from './contact-person/contact-person.component';
import {AuthGuardService} from './guards/auth-guard.service';


// variables
const routes: Routes = [
  // open routes (accessible by anyone)
  {
    path: AppConstants.userRegistrationPath,
    component: UserRegistrationComponent
  },
  {
    path: AppConstants.confirmationPage,
    component: ConfirmationPageComponent
  },
  {
    path: AppConstants.confirmRegistration,
    component: EmailConfirmationComponent,
    data: {kind: 'registration'}
  },
  {
    path: AppConstants.verifyEmail,
    component: EmailConfirmationComponent,
    data: {kind: 'email'}
  },
  // {
  //   path: AppConstants.verifyEmailSetupPassword,
  //   component: ChangePasswordComponent
  // },
  {
    path: AppConstants.newsletterAgreement,
    component: NewsletterAgreementComponent
  },
  {
    path: AppConstants.forgotPassword,
    component: ForgotPasswordComponent
  },
  {
    path: AppConstants.resetPassword,
    component: ResetPasswordComponent
  },
  {
    path: AppConstants.error,
    component: ErrorPageComponent,
  },
  // secured routes (authentication and backend verification required)
  {
    path: '',
    canActivateChild: [AuthGuardService],
    children: [
      {
        path: AppConstants.adminUsersOverviewPath,
        component: AdminUsersOverviewComponent,
      },
      {
        path: AppConstants.customerUserDetailPath + '/:id',
        component: CustomerAdminUserDetailsComponent,
        resolve: {
          user: UserResolve
        },
        canDeactivate: [UnsavedChangesGuard]
      },
      {
        path: AppConstants.customerUserDetailPath,
        component: CustomerAdminUserDetailsComponent,
        // canActivate: [AuthGuardService]
      },
      {
        path: AppConstants.slxUserDetailPath + '/:id',
        component: SlxAdminUserDetailsComponent,
        resolve: {
          user: UserResolve
        },
        canDeactivate: [UnsavedChangesGuard]
      },
      {
        path: AppConstants.slxUserDetailPath,
        component: SlxAdminUserDetailsComponent
      },
      {
        path: AppConstants.homePage,
        component: EntryPageComponent
      },
      {
        path: AppConstants.slxAdminManageUsers,
        component: SlxAdminManageUsersComponent
      },
      {
        path: AppConstants.myProfile,
        component: UpdateMyProfileComponent,
        canDeactivate: [UnsavedChangesGuard]
      },
      {
        path: AppConstants.slxAdminManageCustomers,
        component: SlxAdminManageCustomersComponent
      },
      {
        path: AppConstants.myProfilechangePassword,
        component: MyProfileChangePasswordComponent
      },
      {
        path: AppConstants.changeCompanyData,
        component: MyCompanyDataComponent,
        canDeactivate: [UnsavedChangesGuard]
      },
      {
        path: AppConstants.createCustomer,
        component: CreateEditCustomerComponent
      },
      {
        path: AppConstants.contactPerson,
        component: ContactPersonComponent
      },
      {
        path: AppConstants.editCustomer + '/:customerNumber',
        component: CreateEditCustomerComponent,
        canDeactivate: [UnsavedChangesGuard]
      },
      {
        path: AppConstants.unmatchedPath,
        redirectTo: AppConstants.homePage,
        pathMatch: 'full'
      }
    ]
  }];


/**
 * @description Modularity system which helps organize the app into cohesive blocks of functionality
 * @example https://angular.io/guide/architecture#modules
 * @tutorial https://angular.io/guide/ngmodule
 */
@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: false })],
  exports: [RouterModule]
})

export class AppRoutingModule {
}
